module.exports = "<section class=\"practice-requirements\">\r\n  <app-skill-document-card\r\n    [document]=\"document\"\r\n    [isAvailable]=\"hasDocument\"\r\n    [showDisabledDownloadButton]=\"true\"\r\n    downloadLabel=\"SKILL_LEARNING_COMMON_DOWNLOAD_DOCUMENT\"\r\n    (downloadRequested)=\"onDownload()\">\r\n  </app-skill-document-card>\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/user/practice-level/practice-requirements.component.html
// module id = ../../../../../src/app/content-page/common/skill-learning/components/user/practice-level/practice-requirements.component.html
// module chunks = main